module.exports = __webpack_public_path__ + "BradescoSans-Bold.d6adbfa0e112512e1f3b.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Bold.woff2
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Bold.woff2
// module chunks = main